export const formatValue = (value, maxCharacters = 40) => {
  if (!value) {
    return value
  }

  switch (true) {
    case Array.isArray(value): {
      let formatted = ''
      if (value.every((val) => typeof val === 'string')) {
        formatted = value.join(', ')
      } else {
        formatted = value.map(({ name, label }) => (label ? label : name)).join(', ')
      }

      return formatted.length > maxCharacters
        ? `${formatted.slice(0, maxCharacters - 1)}...`
        : formatted
    }
    case value.length > maxCharacters:
      return `${value.slice(0, maxCharacters - 1)}...`
    case typeof value === 'string':
      return value
    case value === true:
      return 'True'
    case value === false:
      return 'False'
    default:
      return false
  }
}
